import type { ProductivitySummary } from '@cobliteam/common-types';
import camelcaseKeys from 'camelcase-keys';
import snakeCaseKeys from 'snakecase-keys';
import type { Configuration, IRequest, TimeseriesChart } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';
import type { ProductivitySummaryRequest, ProductivityTimeSeriesChartRequest } from './Types';

export class ProductivityRequester {
  private requester: Requester;

  private baseURL = '/analytics/v1/productivity';

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getVehicleProductivitySummary = (request: ProductivitySummaryRequest): Promise<ProductivitySummary> => {
    return this.getSummary(request, 'vehicle');
  };

  public getDriverProductivitySummary = (request: ProductivitySummaryRequest): Promise<ProductivitySummary> => {
    return this.getSummary(request, 'driver');
  };

  public getProductivityTimeSeriesChart = async (body: ProductivityTimeSeriesChartRequest): Promise<TimeseriesChart[]> => {
    const bodyWithTimezone = {
      ...body,
      timezone: TimeZone.getTimezone(),
    };

    const requestData: IRequest = {
      endpoint: `${this.baseURL}/charts/timeseries`,
      method: HttpMethod.POST,
      body: JSON.stringify(snakeCaseKeys(bodyWithTimezone)),
    };

    const response = await this.requester.request(requestData);
    return camelcaseKeys(response.data.data, { deep: true });
  };

  private getSummary = (request: ProductivitySummaryRequest, entity: 'vehicle' | 'driver'): Promise<ProductivitySummary> => {
    const requestBody = {
      ...request,
      timezone: TimeZone.getTimezone(),
    };

    const requestData: IRequest = {
      endpoint: `${this.baseURL}/${entity}/summary`,
      method: HttpMethod.POST,
      body: JSON.stringify(snakeCaseKeys(requestBody)),
    };

    return this.requester.request(requestData).then((response) => {
      const rawSummary = response.data.data;
      return camelcaseKeys(rawSummary, { deep: true });
    });
  };
}

export default ProductivityRequester;
